import { createGlobalStyle } from '../styled-components'
import { Utils } from '../Utils'

export const FontsCSS = createGlobalStyle`
  @font-face {
    font-family: 'museo-sans';
    src:url('${Utils.getAssetPath('/assets/MuseoSans-300.eot')}');
    src:url('${Utils.getAssetPath('/assets/MuseoSans-300.eot?#iefix')}') format('embedded-opentype'),
    url('${Utils.getAssetPath('/assets/MuseoSans-300.ttf')}') format('truetype'),
    url('${Utils.getAssetPath('/assets/MuseoSans-300.woff')}') format('woff'),
    url('${Utils.getAssetPath('/assets/MuseoSans-300.svg#icofonts')}') format('svg');
    font-weight: 300;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'museo-sans';
    src:url('${Utils.getAssetPath('/assets/MuseoSans-500.eot')}');
    src:url('${Utils.getAssetPath('/assets/MuseoSans-500.eot?#iefix')}') format('embedded-opentype'),
    url('${Utils.getAssetPath('/assets/MuseoSans-500.ttf')}') format('truetype'),
    url('${Utils.getAssetPath('/assets/MuseoSans-500.woff')}') format('woff'),
    url('${Utils.getAssetPath('/assets/MuseoSans-500.svg#icofonts')}') format('svg');
    font-weight: 500;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'museo-sans';
    src:url('${Utils.getAssetPath('/assets/MuseoSans-700.eot')}');
    src:url('${Utils.getAssetPath('/assets/MuseoSans-700.eot?#iefix')}') format('embedded-opentype'),
    url('${Utils.getAssetPath('/assets/MuseoSans-700.ttf')}') format('truetype'),
    url('${Utils.getAssetPath('/assets/MuseoSans-700.woff')}') format('woff'),
    url('${Utils.getAssetPath('/assets/MuseoSans-700.svg#icofonts')}') format('svg');
    font-weight: 700;
    font-style: normal;
  }
  
`
